import { render, staticRenderFns } from "./ClaimProfile.vue?vue&type=template&id=e2ef1056&scoped=true&"
import script from "./ClaimProfile.vue?vue&type=script&lang=js&"
export * from "./ClaimProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClaimProfile.vue?vue&type=style&index=0&id=e2ef1056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ef1056",
  null
  
)

export default component.exports